// Takes array of objects and sorts them by string value
export const sortByValue = (array, property) =>
  array.sort((a, b) => (a[property] > b[property] ? 1 : b[property] > a[property] ? -1 : 0));
